export const defaultRouter = [
    {
        path: '/404',
        name: "404",
        component: () => import('../components/erro/erro_404.vue')   
    },
    {
        path: '/405',
        name: "405",
        component: () => import('../components/erro/erro_405.vue')   
    },
];


// WEBPACK FOOTER //
// ./src/router/defaultRouter.js